import React from "react";

export default React.createContext({
  openTabs: [],
  uid:'',
  view:'',
  processCompareView:'',
  network:{},
  handleAddTab: () => {},
  handleRemoveTab: () => {},
  handleUid: () => {},
  selectFilter:() => {},
  handleEvents_cases: () => {},
  actionFilter: () => {},
  selectView: () => {},
  handleAutoSave:() => {},
  handleListOfVariants:() => {},
  handleConformanceCheckingData: () => {},
  handleWorkspace:() => {},
  handleWorkspacesInfo:() => {},
  handleAnalysis:() => {},
  handleSelectedWorkspaceInfo:() => {},
  handleSelectedVariantsFromFilter:() => {},
  handleCompareId:() => {},
  handleCompareColor:() => {},
  handleChangeVariantsFilter:() => {},
  handleDataChartCompare:() => {},
  conformanceCheckingData: {},
  handleLayerList:() => {},
  handleAllowGetTab:() => {},
  handleLostWorkspaceDataConnector: () => {},
  onlineStatus: true,
  handleSaveAnalysisStatus: () => {},
  handleDisableCostProperty: () => {},
  handleSaveWorkspaceStatus: () => {},
  handleSaveGenerateBpmnFilters: () => {},
  handleExplorerActiveTab: () => {},
  handleFiltersSubmitClicked: () => {},
  handleHasSavedFilters: () => {},
  handleOverrideDataAnalysisFilters: () => {},
  handleCaseCoverageData: () => {},
  handleProcessCompareSecondLayerInfos: () => {},
  handleLayersFilters: () => {},
  handleIsFiltersModalOpen: () => {},
  handleIsClickedOnLayerSelection: () => {},
  handleIsVariantExplorerLinked: () => {},
  handleApiStatusProcessExplorer: () => {},
  handleCallbackUrl: () => {}
});
